import { formatCurrency } from '../../Functions'

const Table = ({state}) => {
  return (
    <div className="row mt-2">
      <div className="card col-xxl-12">
        <div className={`table-responsive ${state.loading ? 'table-loading-overlay' : ''}`}>
          <table className="table table-row-bordered table-payment-datail">
            <thead className="fs-5 text-gray-400">
              <tr>
                <th colSpan={10}>&nbsp;</th>
                <th colSpan={3} className='text-center'>BONO / SEGURO</th>
                <th colSpan={3} className='text-center'>COPAGO</th>
                <th colSpan={2}>&nbsp;</th>
              </tr>
              <tr>
                <th> N° Rol </th>
                <th> Sucursal </th>
                <th> Nombre Paciente </th>
                <th> Fecha Hosp. </th>
                <th> Fecha Alta </th>
                <th> Previsión </th>
                <th> Código Prestación </th>
                <th> Acción </th>
                <th> N° </th>
                <th> Tipo PAM </th>
                <th> Monto Prestación </th>
                <th> Monto </th>
                <th> Fecha Últ. Proceso </th>
                <th> Fecha Últ. Pago </th>
                <th> Monto </th>
                <th> Fecha Últ. Proceso </th>
                <th> Fecha Últ. Pago </th>
                <th> Saldo Prestación </th>
                <th> Estado </th>
              </tr>
            </thead>
            <tbody className="fs-7 text-gray-800">
              {state.data.length > 0 && state.data.map((row, index) => (
                <tr key={index}>
                  <td>{row.numerorol}</td>
                  <td>{row.nombre_sucursal}</td>
                  <td>{row.nombrepaciente}</td>
                  <td>{row.fechahospitalizacion}</td>
                  <td>{row.fechaalta}</td>
                  <td>{row.prevision}</td>
                  <td>{row.codigoprestacion}</td>
                  <td>{row.accion}</td>
                  <td>{row.numero}</td>
                  <td>{row.tipopam}</td>
                  <td>{formatCurrency(row.montoprestacion)}</td>
                  <td>{formatCurrency(row.bs_monto)}</td>
                  <td>{row.bs_fecha_ultimo_proceso}</td>
                  <td>{row.bs_fecha_utlimo_pago}</td>
                  <td>{formatCurrency(row.cp_monto)}</td>
                  <td>{row.cp_fecha_ultimo_proceso}</td>
                  <td>{row.cp_fecha_ultimo_pago}</td>
                  <td>{formatCurrency(row.saldoprestacion)}</td>
                  <td>{row.estado}</td>
                </tr>))}
              {[...Array(10 - state.data.length)].map((row, index) => (
                <tr key={index}>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Table